export var StatusIconType;
(function (StatusIconType) {
    StatusIconType["IconDisabled"] = "IconDisabled";
    StatusIconType["IconAlertCircleFill"] = "IconAlertCircleFill";
    StatusIconType["IconAlertTriangleFill"] = "IconAlertTriangleFill";
    StatusIconType["IconCheckCircleFill"] = "IconCheckCircleFill";
    StatusIconType["IconInformationFill"] = "IconInformationFill";
})(StatusIconType || (StatusIconType = {}));
